import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ModalTerceiro = async () => {
  const result = await MySwal.fire({
    title: 'Finalização da Viagem - Terceiro',
    html: `
      <input 
        id="swal-nome-terceiro" 
        class="swal2-input" 
        placeholder="Nome do terceiro"
        maxlength="100"
      />
    `,
    showCancelButton: true,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
    focusConfirm: false,
    preConfirm: () => {
      const nome_terceiro = document.getElementById('swal-nome-terceiro').value;
      if (!nome_terceiro) {
        Swal.showValidationMessage('Campo obrigatório');
        return false;
      }

      if (nome_terceiro > 100) {
        Swal.showValidationMessage('Máximo de 100 caracteres');
        return false;
      }

      return { nome_terceiro };
    }
  });

  if (!result.isConfirmed) return null;

  return result.value;
};

export default ModalTerceiro;


  